module.exports = __webpack_public_path__ + "img/bg-left-diamond-grey-2.d9e8b15.png";